
import type {UserModule} from '@/types'
import VueGtag from 'vue-gtag-next'
import {appendOptionalAnalyticsScript} from '@/composables/analyticsScript'

export const install: UserModule = ({ app, isClient }) => {
    const measurementId = import.meta.env.VITE_GA_ID

    app.use(VueGtag, {
        property:{
            id: measurementId,
            params:{
                send_page_view: true
            }
        },
        // vue-gtag's built-in script loader creates a rejecting Promise without
        // a rejection handler. Load this optional provider below with an error
        // event instead, so a blocked analytics request cannot become an
        // unhandled application rejection.
        disableScriptLoader: true,
    })

    if (isClient) {
        appendOptionalAnalyticsScript(document, measurementId)
    }
};
